export default __webpack_public_path__ + "static/media/facebook.44f8de50.svg";